import { useState } from "react";
import { sendMagicLink } from "../../firebase/auth.js";

// Standalone magic-link sign-in (used by the dashboard when not authed).
export default function SignIn() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await sendMagicLink(email, "/app");
      setSent(true);
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="container center" style={{ paddingTop: 120, maxWidth: 480 }}>
        <h2>Check your inbox ✉️</h2>
        <p className="muted">We sent a sign-in link to <strong>{email}</strong>.</p>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: 96, maxWidth: 420 }}>
      <h1>Sign in</h1>
      <p className="muted">Passwordless — we email you a secure link.</p>
      <form onSubmit={submit} className="stack" style={{ marginTop: 16 }}>
        <input className="input" type="email" placeholder="you@example.com"
          value={email} onChange={(e) => setEmail(e.target.value)} required />
        {err && <p className="error">{err}</p>}
        <button className="btn" disabled={busy || !email}>{busy ? "Sending…" : "Email me a link"}</button>
      </form>
    </div>
  );
}
